import useWindowSize from './use-window-size';
import {
  DEFAULT_MOBILE_BREAKPOINT,
  MOBILE_CUTOFF,
  MOBILE_TINY_BREAKPOINT,
  NW_MOBILE_BREAKPOINT,
} from '../lib/constants';

type isMobileResults = {
  isTinyMobile: boolean;
  isMobileLegacyOrSmaller: boolean;
  isMobileOrSmaller: boolean;
  isTabletOrSmaller: boolean;
  isNavNarrow: boolean;
};

// These breakpoints are defined in https://github.com/NerdWallet/compass/blob/master/src/nav2/less/breakpoints.module.less
const NAV_MID_BREAKPOINT = 1280;

/**
 * Hook that returns if current window should be using mobile layout
 * Notice that in SSR this will return false for all
 */
const useIsMobile = (): isMobileResults => {
  const { width } = useWindowSize();

  if (typeof window === 'undefined') {
    return {
      isTinyMobile: false,
      isMobileLegacyOrSmaller: false,
      isMobileOrSmaller: false,
      isTabletOrSmaller: false,
      isNavNarrow: false,
    };
  }

  return {
    isTinyMobile: width < MOBILE_TINY_BREAKPOINT,
    isMobileLegacyOrSmaller: width < MOBILE_CUTOFF,
    isMobileOrSmaller: width < NW_MOBILE_BREAKPOINT,
    isTabletOrSmaller: width < DEFAULT_MOBILE_BREAKPOINT,
    isNavNarrow: width <= NAV_MID_BREAKPOINT - 1,
  };
};

export default useIsMobile;
